import { render } from "./RecipeBrowser.vue?vue&type=template&id=9c8d469c&scoped=true"
import script from "./RecipeBrowser.vue?vue&type=script&lang=js"
export * from "./RecipeBrowser.vue?vue&type=script&lang=js"

import "./RecipeBrowser.vue?vue&type=style&index=0&id=9c8d469c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c8d469c"]])

export default __exports__